import React, { createRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import PropTypes from "prop-types";
import { showMultipleToasts } from "../../utils/apiSetup";

export const PolicyTimeline = (props) => {
  const { setClickedPolicyVersionDateAndStatus, partyId } = props;
  const { sipasuuid } = useParams();

  const ref = createRef();

  const { t } = useTranslation();

  const policyTimelineTranslations = t("portal:widgets.policyTimeline", {
    returnObjects: true,
    interpolation: { skipOnVariables: true },
  });

  const handleTimelineClick = (e) => {
    const { versionDate, latest } = e.detail;

    setClickedPolicyVersionDateAndStatus({
      policyVersionDate: versionDate,
      status: latest ? "active" : "historic",
    });
  };

  const handleReturnErrors = (event) => {
    const { errors } = event.detail;

    if (errors) {
      showMultipleToasts(errors);
    }
  };

  const handleReturnMessages = (event) => {
    const { messages } = event.detail;

    if (messages) {
      showMultipleToasts(messages);
    }
  };

  useEffect(() => {
    if (ref && ref.current) {
      ref.current.addEventListener("policytimeline-view", handleTimelineClick);
      ref.current.addEventListener("widget-error", handleReturnErrors);
      ref.current.addEventListener("widget-message", handleReturnMessages);
    }

    return () => {
      if (ref && ref.current) {
        ref.current.removeEventListener("policytimeline-view", handleTimelineClick);
        ref.current.removeEventListener("widget-error", handleReturnErrors);
        ref.current.removeEventListener("widget-message", handleReturnMessages);
      }
    };
  }, [sipasuuid]);

  return (
    <ds-portfolio-policytimeline-widget
      ref={ref}
      variant="policyTimeline"
      sipasuuid={sipasuuid}
      partyid={partyId}
      translations={JSON.stringify({ policyTimeline: policyTimelineTranslations })}
    />
  );
};

PolicyTimeline.propTypes = {
  setClickedPolicyVersionDateAndStatus: PropTypes.func,
  partyId: PropTypes.string,
};
